The response from the `createUnpostedPositionProfileForOpening` mutation.
